import { render, staticRenderFns } from "./BaseCheckBox.vue?vue&type=template&id=351370bb&scoped=true&"
import script from "./BaseCheckBox.vue?vue&type=script&lang=js&"
export * from "./BaseCheckBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCheckBox.vue?vue&type=style&index=0&id=351370bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "351370bb",
  null
  
)

export default component.exports